import { addAlert } from '@state/alertSlice';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAlert = () => {
    const dispatch = useDispatch();

    const success = useCallback(
        (message: string) => {
            dispatch(addAlert({ message, type: 'success' }));
        },
        [dispatch],
    );

    const error = useCallback(
        (message: string) => {
            dispatch(addAlert({ message, type: 'error' }));
        },
        [dispatch],
    );

    const info = useCallback(
        (message: string) => {
            dispatch(addAlert({ message, type: 'info' }));
        },
        [dispatch],
    );

    const warning = useCallback(
        (message: string) => {
            dispatch(addAlert({ message, type: 'warning' }));
        },
        [dispatch],
    );

    return { success, error, info, warning };
};
